import React, { PropsWithChildren } from 'react';
import { List } from '../../components/List';
import { identifyComponent } from '../../util';

interface OptionProps {
  compact?: React.ComponentProps<typeof List>['compact'];
}

export const Options: React.FunctionComponent<PropsWithChildren<OptionProps>> = ({
  children,
  compact,
}) => (
  <List
    data-component="Options"
    compact={compact}
    role="listbox"
    disablePadding
    {...identifyComponent('options')}
  >
    {children}
  </List>
);
